import React from 'react'
var AboutHeaders={
    backgroundImage: 
    "url('/images/BannerImages/ContactHero.png')",
    marginTop:"0px"
  }
export default function ContactHero() {
  return (
    <>
      <section id="Contact_hero" style={AboutHeaders}>
        <h2>#Let's Talk</h2>    
        <p>LEAVE A MESSAGE, we love to hear from you!</p>
    </section>
    </>
  )
}
